<dsy-table zebraShadowRows [data]="tableDataSignal()" [conf]="tableConfSignal()">
  @for (col of columnsSignal(); track col.key) {
    <div [attr.slot]="'header-' + col.key">
      @if (col.key === 'checkbox') {
        <dsy-checkbox [dsyValue]="selectionStore.allSelectedSignal()" [handleChange]="handleToggleAll" event-bubbles is-event-composed size="small"></dsy-checkbox>
      } @else {
        <dsy-heading level-size="lg">{{ col.header }}</dsy-heading>
      }
    </div>
  }
  @for (row of rowsSignal(); track row.id; let i = $index) {
    <dsy-checkbox
      slot="cell-{{ i }}-checkbox"
      aria-label="Select row"
      [dsyValue]="isSelected(row.id)"
      [handleChange]="handleToggleRow(row.id)"
      event-bubbles
      is-event-composed
      size="small"
    />

    <p class="handover__cell" slot="cell-{{ i }}-program">{{ row.programName }}</p>
    <p class="handover__cell" slot="cell-{{ i }}-activity">
      @switch (row.activity.toLowerCase()) {
        @case ('actionable') {
          <dsy-icon library="material" name="check_circle_outline" size="1.5rem"></dsy-icon>
        }

        @case ('need-to-know') {
          <dsy-icon library="material" name="info" size="1.5rem"> </dsy-icon>
        }

        @default {
          <span>{{ row.activity }}</span>
        }
      }
    </p>
    <p class="handover__cell handover__cell--createdBy" slot="cell-{{ i }}-createdBy">
      <dsy-avatar
        size="x-small"
        resource-url="assets/images/avatar-placeholder.png"
        is-fullname-visible
        [firstName]="row.createdByName"
        [lastName]="''"
        fullname-additional-style="padding-left: 0.5rem"
      />
    </p>
    <div class="handover__cell due-cell" slot="cell-{{ i }}-dueDate">
      {{ row.dueDate | date: 'dd/MM/yy - hh:mm a' }}
      @if (row.tagVariant) {
        <dr-ops-stream-ui-app-tag size="sm" [variant]="row.tagVariant!" [label]="row.tagLabel!"></dr-ops-stream-ui-app-tag>
      }
    </div>
    <p class="handover__cell handover__cell--notes" slot="cell-{{ i }}-notes">{{ row.notes }}</p>
    @if (selectedOpsStreamTypeSignal() == opsStreamType.PENDING) {
      <p class="handover__cell handover__cell--edit" slot="cell-{{ i }}-action">
        <dsy-clickable-icon name="edit_square" library="material" size="1.4rem" color="default" (click)="onEdit(row)" />
      </p>
    }
    <p class="handover__cell" slot="cell-{{ i }}-action">
      <dsy-button variant="link" [iconSide]="'right'" [iconName]="'chevron_right'" [iconLibrary]="'material'" [iconSize]="'1.4rem'" (click)="onView(row)"> View </dsy-button>
    </p>
  }
</dsy-table>
